import React from "react";
import { Box, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";
import MediaCard from "./MediaCard";

const BasicCard = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Card
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          This is simple basic card.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor height={"300px"} language="js" value={""}>
          <MediaCard />
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default BasicCard;
